import {
  DbWorkflowTaskState,
  useDeleteApiWorkflowsTaskStatesByStateMutation,
  useGetApiWorkflowsTaskStatesQuery,
  usePatchApiWorkflowsTaskStatesByStateMutation,
  usePostApiWorkflowsTaskStatesMutation,
} from '../../../../app/athenaApiGen';
import AdminCatalogPanel from '../AdminCatalogPanel';

// WorkflowTaskState — same shape as WorkflowState. Path param is `state`.
const AdminWorkflowTaskStatesPanel = () => (
  <AdminCatalogPanel<DbWorkflowTaskState>
    tableName="Workflow Task State"
    apiPath="/api/workflows/task-states"
    pkAccessor="workflowTaskState"
    useList={() => useGetApiWorkflowsTaskStatesQuery({ archived: true })}
    useCreate={usePostApiWorkflowsTaskStatesMutation}
    useUpdate={usePatchApiWorkflowsTaskStatesByStateMutation}
    useDelete={useDeleteApiWorkflowsTaskStatesByStateMutation}
    buildCreateArg={(v) => ({
      handlersWorkflowCatalogRequest: {
        name: (v.workflowTaskState as string) ?? '',
        description: v.description as string | undefined,
      },
    })}
    buildUpdateArg={(row, v) => ({
      state: row.workflowTaskState as string,
      handlersWorkflowCatalogUpdateRequest: {
        description: v.description as string | undefined,
      },
    })}
    buildDeleteArg={(row) => ({ state: row.workflowTaskState as string })}
    fields={[
      {
        name: 'workflowTaskState',
        label: 'Workflow Task State',
        type: 'text',
        required: true,
        immutableOnEdit: true,
      },
      { name: 'description', label: 'Description', type: 'textarea' },
      { name: 'archived', label: 'Archived', type: 'boolean' },
    ]}
    fkConflictMessage="Active workflow tasks still reference this state."
  />
);

export default AdminWorkflowTaskStatesPanel;
